var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYouTube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6505 7.35662C37.3637 7.81805 38.7147 9.16875 39.1759 10.8823C40.0328 14.0122 39.9998 20.5362 39.9998 20.5362C39.9998 20.5362 39.9998 27.0269 39.1762 30.1571C38.7147 31.8704 37.364 33.2214 35.6505 33.6825C32.5203 34.5065 19.9999 34.5065 19.9999 34.5065C19.9999 34.5065 7.51218 34.5065 4.34935 33.6498C2.63579 33.1884 1.28509 31.8374 0.823666 30.1242C0 27.0269 0 20.5032 0 20.5032C0 20.5032 0 14.0122 0.823666 10.8823C1.28478 9.16905 2.66875 7.78509 4.34904 7.32397C7.47922 6.5 19.9996 6.5 19.9996 6.5C19.9996 6.5 32.5203 6.5 35.6505 7.35662ZM26.4248 20.5033L16.0131 26.5V14.5066L26.4248 20.5033Z",
    fill: "#F2F2F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.b74230e081428e0c6137fa7bc80a28ca.svg";
export { ForwardRef as ReactComponent };